import { useOptionalPrivanaI18n } from '@/i18n/PrivanaI18nProvider'
import React from 'react'
import { Link } from 'react-router-dom'
import { CalendarPlus, Users } from 'lucide-react'
import { format, parseISO } from 'date-fns'

function formatSession(value, locale, timeZone, memberText) {
  if (!value) return memberText("portalPresentation.member_no_upcoming_sessions")
  try {
    return new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'short', ...(timeZone ? { timeZone } : {}) }).format(parseISO(value))
  } catch {
    return value
  }
}

export default function MemberManageActivitiesPage({ clubCode, activities }) {
  const { t: memberText, locale } = useOptionalPrivanaI18n()
  return (
    <div className="mp-panel">
      <div className="mp-panel__header">
        <div>
          <p className="mp-eyebrow"> {memberText("golf.course.manage")} </p>
          <h4 className="mp-panel__title"> {memberText("portalPresentation.member_manage_activities")} </h4>
        </div>
      </div>

      {activities.length === 0 ? (
        <div className="mp-panel__body">
          <div className="mp-empty"> {memberText("portalPresentation.member_you_are_not_assigned_to_any_activities")} </div>
        </div>
      ) : (
        <div className="mp-manage-grid">
          {activities.map((activity) => (
            <div key={activity.id} className="mp-manage-card">
              <div>
                <p className="mp-manage-card__label"> {memberText("portalPresentation.member_managed_activity")} </p>
                <p className="mp-manage-card__title">{activity.name}</p>
                <div className="mp-manage-card__meta">
                  <CalendarPlus size={14} />
                  {formatSession(activity.next_session_starts_at, locale, activity.time_zone, memberText)}
                </div>
                <div className="mp-manage-card__meta">
                  {memberText(activity.upcoming_sessions_count === 1 ? 'portalPresentation.member__count_upcoming_session' : 'portalPresentation.member__count_upcoming_sessions', { count: activity.upcoming_sessions_count })}
                </div>
              </div>
              <div className="mp-manage-card__actions">
                <Link
                  className="mp-btn mp-btn--outline mp-btn--sm"
                  to={`/${clubCode}/manage/activities/${activity.id}`}
                > {memberText("portalPresentation.member_manage_sessions")} </Link>
                <Link
                  className="mp-btn mp-btn--primary mp-btn--sm"
                  to={`/${clubCode}/manage/activities/${activity.id}`}
                >
                  <Users size={14} /> {memberText("portalPresentation.member_view_roster")} </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
